import { Controller } from '@hotwired/stimulus';
import debounce from 'lodash/debounce';
import mailcheck from '../src/utils/mailcheck';

type Suggestion = { address: string; domain: string; full: string };

export default class EmailSuggestionController extends Controller<HTMLElement> {
  static targets = ['input', 'suggestion', 'address', 'domain'];

  declare readonly inputTarget: HTMLInputElement;

  declare readonly suggestionTarget: HTMLElement;

  declare readonly addressTarget: HTMLElement;

  declare readonly domainTarget: HTMLElement;

  private suggested = '';

  checkWhileTyping = debounce(() => this.check(), 350);

  check(): void {
    mailcheck.run({
      email: this.inputTarget.value,
      suggested: (suggestion: Suggestion) => this.show(suggestion),
      empty: () => this.hide(),
    });
  }

  accept(): void {
    this.checkWhileTyping.cancel();
    this.inputTarget.value = this.suggested;
    this.hide();
    this.dispatch('accepted', { target: this.inputTarget });
  }

  private show({ address, domain, full }: Suggestion): void {
    this.suggested = full;
    this.addressTarget.textContent = `${address}@`;
    this.domainTarget.textContent = domain;
    this.suggestionTarget.classList.remove('hidden');
  }

  private hide(): void {
    this.suggestionTarget.classList.add('hidden');
  }
}
